// extracted by mini-css-extract-plugin
export default {"container":"CoverEditor_container__xb8cc","canvas":"CoverEditor_canvas__qVFqN"};